
<template>
  <div class="animated fadeIn">
    <b-row>
        <b-col lg="12">
            <b-card v-if="tieneAcceso === false">
            <div slot="header">
                <strong>Crear Siniestro</strong>
            </div>
            <b-row>
                <b-col lg="12">
                <p>Acceso restringido</p>
                </b-col>
            </b-row>
            </b-card>

        

            <b-card  no-body
            title="Crear Siniestro"
            v-if="cardPoliza === true"
            >

            <b-tabs v-model="tabIndex" lazy>
                <b-tab title="Datos de la Póliza" id= "tabPoliza" active @click="defIndex(0)">
                    <b-card>
                    <b-container fluid>
                        <!-- 1era linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="6"></b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label> N° Ordinario</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-input v-model="datosFormulario.nroordinario"  size="sm"></b-form-input>
                            </b-col>
                            
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>N° Siniestro</label>    
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-input v-model="datosFormulario.nrosiniestro" @change="buscar" size="sm"></b-form-input>
                            </b-col>
                        </b-row>
                        <!-- 2da linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label>Sucursal</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-input v-model="datosFormulario.sucursal"  size="sm"></b-form-input>
                                
                            </b-col>

                            <b-col class="col-sm-per" sm ="6"> </b-col>
                            
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Estado</label>    
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-input-group size="sm">
                                    <b-form-select v-model="datosFormulario.estado" :options="lovEstado" size="sm" ></b-form-select> 
                                    <b-button size="sm" variant="info" @click="VerDetEstado">...</b-button>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <!-- 3era linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label>Fe. Est Pago</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-input v-model="datosFormulario.feestpago"  size="sm" disabled></b-form-input>
                            </b-col>

                            <b-col class="col-sm-per" sm ="5"></b-col>

                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Asist. Sin.</label>    
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.asistente"  size="sm"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Ejec. Sin.</label>    
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.ejecutivo"  size="sm"></b-form-input>
                            </b-col>
                        </b-row>
                        <!-- 4ta linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label>Póliza</label>
                            </b-col>
                            <b-col class="col-sm-per" sm="2">
                                <b-form-input  v-model="datosFormulario.poliza" @change="buscar" size="sm"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1" >
                                <b-form-input v-model="datosFormulario.producto"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Mon.</label>    
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.moneda"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Vig. desde</label>    
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.vigdesde"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Vig. hasta</label>    
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.vighasta"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Venc ult prorr.</label>    
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.fevencultprorr"  size="sm" disabled></b-form-input>
                            </b-col>
                        </b-row>
                        <!-- 5ta linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label> Cobertura</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.codcobertura"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-input v-model="datosFormulario.descobertura"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="5"></b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label> Condicionado</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-input v-model="datosFormulario.condicionado"  size="sm" disabled></b-form-input>
                            </b-col>
                            
                        </b-row>
                        <!-- 6ta linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label> Contratante</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.codcontratante"  size="sm"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.rutcontratante"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="4">
                                <b-form-input v-model="datosFormulario.nomcontratante"  size="sm" disabled></b-form-input>
                            </b-col>
                            
                        </b-row>

                        <!-- 7ma linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label> Afianzado</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.codafianzado"  size="sm"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.rutafianzado"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="4">
                                <b-form-input v-model="datosFormulario.nomafianzado"  size="sm" disabled></b-form-input>
                            </b-col>
                            
                        </b-row>

                        <!-- 8va linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label>País</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.nacion"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Item</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1" >
                                <b-form-input v-model="datosFormulario.item"  size="sm"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Endoso</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.endoso"  size="sm"></b-form-input>
                            </b-col>
                            
                        </b-row>
                        
                        <!-- 9na linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label>Asegurado</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.codasegurado"  size="sm"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.rutasegurado"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="4">
                                <b-form-input v-model="datosFormulario.nomasegurado"  size="sm" disabled></b-form-input>
                            </b-col>
                            
                        </b-row>

                        <!-- 10ma linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label>Beneficiario</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.codbeneficiario"  size="sm"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.rutbeneficiario"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="4">
                                <b-input-group size="sm">
                                    <b-form-input v-model="datosFormulario.nombeneficiario"  size="sm" disabled></b-form-input>
                                    <b-button v-if="this.verbenef === true" size="sm" variant="info"  @click="detalleBeneficiarios(datosFormulario.nrosiniestro)" style="color: white;"><b>V</b></b-button>
                                </b-input-group>    
                            </b-col>

                            
                        </b-row>
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="12">
                                <label>Observaciones del siniestro</label>
                                <b-form-textarea
                                    id="textarea"
                                    v-model="datosFormulario.sinobservacion"
                                    placeholder="Observaciones..."
                                    rows="3"
                                    max-rows="6"
                                    ></b-form-textarea>
                            </b-col>
                        </b-row>
                        </b-container>
                    </b-card>
            
                </b-tab>
                <b-tab title="Provisión | Configuración" id="tabProvision" @click="defIndex(1)">
					 <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                            <label>N° Siniestro</label>    
                        </b-col>
                        <b-col sm="2"> <b> {{this.datosFormulario.nrosiniestro}}</b></b-col>
                    </b-row>					
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>		  
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Estado</label>    
                            </b-col>
                            <b-col  sm ="2">
                                <b-input-group size="sm">
                                    <b-form-select v-model="datosFormulario.estado" :options="lovEstado" size="sm" ></b-form-select> 
                                    <b-button size="sm" variant="info" @click="VerDetEstado">...</b-button>
                            </b-input-group>
                        </b-col>
                    </b-row>		

                    <b-card header="Provisión"
                            header-tag="header">
                    <b-container fluid >
                        <!-- 1era linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label> Moneda</label>
                                <b-form-input v-model="datosFormulario.monmtoasegurado"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <label>Mto. Asegurado</label>    
                                <b-form-input 
                                    v-model="datosFormulario.mtoasegurado"  
                                    size="sm" disabled
                                    v-mask="{ alias: 'decimal', integerDigits:10, digits:12, digitsOptional: true, groupSeparator: this.$globales.separadorMiles, radixPoint: this.$globales.separadorDecimales, autoGroup: true, rightAlign: true , autoUnmask:true}"
                                    >
                                </b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <label>Mto. Denunciado</label>    
                                <b-form-input 
                                    v-model="datosFormulario.mtodenunciado"  
                                    size="sm"
                                    v-mask="{ alias: 'decimal', integerDigits:10, digits:12, digitsOptional: true, groupSeparator: this.$globales.separadorMiles, radixPoint: this.$globales.separadorDecimales, autoGroup: true, rightAlign: true , autoUnmask:true}"
                                    >

                                </b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <label>Moneda</label>    
                                <b-form-input v-model="datosFormulario.monprovision"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <label>Provisión Total</label>    
                                <b-form-input 
                                    v-model="datosFormulario.totprovision"  
                                    size="sm" 
                                    disabled
                                    v-mask="{ alias: 'decimal', integerDigits:10, digits:12, digitsOptional: true, groupSeparator: this.$globales.separadorMiles, radixPoint: this.$globales.separadorDecimales, autoGroup: true, rightAlign: true , autoUnmask:true}"
                                ></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-group
                                    label="asdf"
                                    label-class="label-blanco"
                                    label-for="buscar"
                                    color="red"
                                    >                                  
                                    <b-button v-if="datosFormulario.nrosiniestro!=''" size="sm" id="Det." variant="primary" @click="provisionar">Det.</b-button>
                                </b-form-group>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                              <br>
                                <label> Retención (%)</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                              <br>
                                <b-form-input 
                                    v-model="datosFormulario.porretencion" 
                                    size="sm" 
                                    disabled
                                    v-mask="{ alias: 'decimal', integerDigits:10, digits:12, digitsOptional: true, groupSeparator: this.$globales.separadorMiles, radixPoint: this.$globales.separadorDecimales, autoGroup: true, rightAlign: true , autoUnmask:true}"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <!-- 2da linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="9"></b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <label>Cod. Dist. Reaseguro</label>    
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">    
                                <b-form-input v-model="datosFormulario.codreaseguro"  size="sm" disabled></b-form-input>
                            </b-col>
                            
                        </b-row>
                        
                    </b-container> 

                    </b-card>   
                    <b-card header="Configuración"
                            header-tag="header">
                        
                        <b-container fluid>
                            <!-- 1era linea  -->
                            <b-row class="my-1" size="sm">
                                <b-col class="col-sm-per" sm ="2">
                                    <label> Motivo de Configuración</label>
                                </b-col>
                                <b-col class="col-sm-per" sm ="3">
                                    <b-form-select v-model="datosFormulario.mtvoconfig" :options="lovMtvoConfig" size="sm" @change="asigfecha" ></b-form-select> 
                                </b-col>
                                <b-col class="col-sm-per" sm ="1">
                                    <label>Fecha Motivo</label>    
                                </b-col>
                                <b-col class="col-sm-per" sm ="2">    
                                    <!-- <b-form-input v-model="datosFormulario.feMotivo"  size="sm" ></b-form-input> -->
                                    <b-form-datepicker 
                                    id="idfeMotivo" 
                                    v-model="datosFormulario.feMotivo" 
                                    :default-value="this.datosFormulario.feMotivo"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                                </b-col>                                
                            </b-row>
                        </b-container> 

                    </b-card> 
                    
                    <b-container fluid>
                                        <!-- 3era linea -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="12">
                                <label>Observaciones del siniestro</label>
                                <b-form-textarea
                                    id="textarea"
                                    v-model="datosFormulario.sinobservacion"
                                    placeholder="Observaciones..."
                                    rows="3"
                                    max-rows="6"
                                    ></b-form-textarea>
                            </b-col>
                        </b-row>
                   </b-container> 
         
                </b-tab>

                <b-tab title="Control Gestión" id="tabCtrlGestion" @click="defIndex(2)">
				    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                            <label>N° Siniestro</label>    
                        </b-col>
                        <b-col sm="2"> <b> {{this.datosFormulario.nrosiniestro}}</b></b-col>
                    </b-row>					
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>		  
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Estado</label>    
                            </b-col>
                            <b-col  sm ="2">
                                <b-input-group size="sm">
                                    <b-form-select v-model="datosFormulario.estado" :options="lovEstado" size="sm" ></b-form-select> 
                                    <b-button size="sm" variant="info" @click="VerDetEstado">...</b-button>
                            </b-input-group>
                        </b-col>
                    </b-row>	
                    <b-card>
                      <b-container fluid>
                        <!-- 1era linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="2">
                                <label> Fecha Denuncio</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosFormulario.fedenuncio"  size="sm"></b-form-input> -->
                                <b-form-datepicker 
                                    id="idfedenuncio" 
                                    v-model="datosFormulario.fedenuncio" 
                                    :default-value="this.datosFormulario.fedenuncio"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>

                            <b-col class="col-sm-per" sm ="3"></b-col>

                            <b-col class="col-sm-per" sm ="2">
                                <b-form-checkbox
                                v-model="datosTabCtrlGestion.ckdoccompleto"
                                value="s"
                                unchecked-value="n"
                                @change="Asgckdoccompleto" 
                                >
                                Fecha Doc. Completos
                                </b-form-checkbox>
                            </b-col>
                            <b-col class="col-sm-per my-0" sm ="2" >
                                <!-- <b-form-input v-model="datosTabCtrlGestion.fedoccompleto"  size="sm" ></b-form-input> -->
                                <b-form-datepicker 
                                    id="idfedoccompleto" 
                                    v-model="datosTabCtrlGestion.fedoccompleto" 
                                    :default-value="this.datosTabCtrlGestion.fedoccompleto"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosTabCtrlGestion.usdoccompleto"  size="sm" disabled></b-form-input>
                            </b-col>
                        </b-row>

                        <!-- 2da linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="2">
                                <label> Fecha Ingreso</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosFormulario.feingreso"  size="sm"></b-form-input> -->
                                <b-form-datepicker 
                                    id="idfeingreso" 
                                    v-model="datosFormulario.feingreso" 
                                    :default-value="this.datosFormulario.feingreso"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    disabled
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>
                            <b-col class="col-sm-per" sm ="3"></b-col>

                            <b-col class="col-sm-per" sm ="2">
                                <b-form-checkbox
                                v-model="datosTabCtrlGestion.ckdocincompleto"
                                value="s"
                                unchecked-value="n"
                                @change="Asgckdocincompleto"
                                >
                                Fecha Doc. Incompletos
                                </b-form-checkbox>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosTabCtrlGestion.fedocincompleto"  size="sm" ></b-form-input> -->
                                <b-form-datepicker 
                                    id="example-datepicker" 
                                    v-model="datosTabCtrlGestion.fedocincompleto"   
                                    :default-value="this.datosTabCtrlGestion.fedocincompleto"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosTabCtrlGestion.usdocincompleto"  size="sm" disabled></b-form-input>
                            </b-col>

                        </b-row>
                        
                        
                        
                        <!-- 3era linea -->
                        <b-row class="my-1" size="sm">   
                            <b-col class="col-sm-per" sm ="2">
                                <label>Fecha Ent. Asist. Env. Liq</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.feentasistenvliq"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.usentasistenvliq"  size="sm" disabled></b-form-input>
                            </b-col>
                            
                            <b-col class="col-sm-per" sm ="1">
                                <label>Fecha Asig. Liq.</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.feasistenvliq"  size="sm" disabled></b-form-input>
                                
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.useasistenvliq"  size="sm" disabled></b-form-input>
                            </b-col>

                            <b-col class="col-sm-per" sm ="2">
                                <b-form-checkbox
                                v-model="datosTabCtrlGestion.cknoasigliq"
                                value="s"
                                unchecked-value="n"
                                @change="Asgcknoasigliq"
                                >
                                No Asig. Liquidador
                                </b-form-checkbox>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosTabCtrlGestion.fenoasigcobr"  size="sm" ></b-form-input> -->
                                <b-form-datepicker 
                                    id="example-datepicker" 
                                    v-model="datosTabCtrlGestion.fenoasigliq" 
                                    :default-value="this.datosTabCtrlGestion.fenoasigliq"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosTabCtrlGestion.usnoasigliq"  size="sm" disabled></b-form-input>
                            </b-col>
                        </b-row>   
                        
                        <!-- 4ta linea -->
                        <b-row class="my-1" size="sm">   
                            <b-col class="col-sm-per" sm ="2">
                                <label>Fecha Est. Config.</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosTabCtrlGestion.feestconfig"  size="sm"></b-form-input> -->
                                <b-form-datepicker 
                                    v-model="datosTabCtrlGestion.feestconfig" 
                                    :default-value="this.datosTabCtrlGestion.feestconfig"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>
                            <b-col sm ="3"></b-col>

                            <b-col class="col-sm-per" sm ="2">
                                <label>Fecha Env. Carta Conf.</label>    
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-input-group size="sm">
                                    <!-- <b-form-input v-model="datosTabCtrlGestion.feenvcartaconf"  size="sm"></b-form-input> -->
                                    <b-form-datepicker 
                                        v-model="datosTabCtrlGestion.feenvcartaconf" 
                                        size="sm" 
                                        :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                        locale="ES"
                                        placeholder="Seleccione fecha"
                                        >
                                    </b-form-datepicker>     
                                    <b-button size="sm" variant="info">...</b-button>
                            </b-input-group>
                            </b-col>
                        </b-row>   
                        
                        <!-- 5ta linea -->
                        <b-row class="my-1" size="sm">   
                            <b-col class="col-sm-per" sm ="2">
                                <label>Fecha Siniestro</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosTabCtrlGestion.fesiniestro"  size="sm"></b-form-input> -->
                                <b-form-datepicker 
                                    v-model="datosTabCtrlGestion.fesiniestro" 
                                    :default-value="this.datosTabCtrlGestion.fesiniestro"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>

                            <b-col sm ="3"></b-col>

                            <b-col class="col-sm-per" sm ="2">
                                <label>Fecha Env. Informe Liq. Ase.</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosTabCtrlGestion.feenvinfliqase"  size="sm"></b-form-input> -->
                                <b-form-datepicker 
                                    v-model="datosTabCtrlGestion.feenvinfliqase" 
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                >
                                </b-form-datepicker> 
                            </b-col>
                        </b-row>   
                        
                        <!-- 5ta linea -->
                        <b-row class="my-1" size="sm"> 
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-checkbox
                                v-model="datosTabCtrlGestion.ckrecepinf"
                                value="s"
                                unchecked-value="n"
                                @change="asgckrecepinf"
                                >
                                Fec. Recepción Informe
                                </b-form-checkbox>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-datepicker 
                                    id="example-datepicker" 
                                    v-model="datosTabCtrlGestion.ferecepinf" 
                                    :default-value="this.datosTabCtrlGestion.ferecepinf"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosTabCtrlGestion.tprecepinf"  size="sm" disabled></b-form-input>
                            </b-col>

                            <b-col sm ="2"></b-col>

                            <b-col class="col-sm-per" sm ="2">
                                <b-form-checkbox
                                    v-model="datosTabCtrlGestion.ckcartcastigo"
                                    value="s"
                                    unchecked-value="n"
                                    @change="asgckcartcastigo"
                                >
                                Fecha Carta Castigo
                                </b-form-checkbox>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosTabCtrlGestion.fecartcastigo"  size="sm" ></b-form-input> -->
                                <b-form-datepicker 
                                    v-model="datosTabCtrlGestion.fecartcastigo" 
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                >
                            </b-form-datepicker> 
                            </b-col>

                        </b-row>   

                        <!-- 6ta linea -->
                        <b-row class="my-1" size="sm">   
                            <b-col class="col-sm-per" sm ="2">
                                <label>Fecha Indemnización</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosTabCtrlGestion.feindemnizacion"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosTabCtrlGestion.usfeindemnizacion"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="3"> </b-col>  

                            <b-col class="col-sm-per" sm ="2">
                                <label>Coaseguro (%)</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosTabCtrlGestion.porccoaseguro"  size="sm"></b-form-input>
                            </b-col>  
                            
                        </b-row>

                        <!-- 7ma linea -->
                        <b-row class="my-1" size="sm">   
                          <b-col class="col-sm-per" sm ="2">
                            <label>Fecha Emi. Cheq. Tesorería</label>
                          </b-col>
                          <b-col class="col-sm-per" sm ="2">
                            <!-- <b-form-input v-model="datosTabCtrlGestion.feemicheqtesore"  size="sm"></b-form-input> -->
                            <b-form-datepicker 
                                v-model="datosTabCtrlGestion.feemicheqtesore" 
                                size="sm" 
                                :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                locale="ES"
                                placeholder="Seleccione fecha"
                                >
                            </b-form-datepicker> 
                          </b-col>
                          
                          <b-col sm ="3"></b-col>
                          
                          <b-col class="col-sm-per" sm ="2">
                            <label>Parte Cubierta</label>
                          </b-col>
                          <b-col class="col-sm-per" sm ="1">
                            <b-form-input v-model="datosTabCtrlGestion.partcubierta"  size="sm"></b-form-input>
                          </b-col>
                        </b-row>

                        <!-- 8va linea -->
                        <b-row class="my-1" size="sm">   
                            <b-col class="col-sm-per" sm ="2">
                                <label>Fecha Ent. Asist. Env. Cob</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.feentasistenvcob"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.usentasistenvcob"  size="sm" disabled></b-form-input>
                            </b-col>

                            <b-col class="col-sm-per" sm ="1">
                                <label>Fecha Asig. Cob.</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.feasistenvcob"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.useasistenvcob"  size="sm" disabled></b-form-input>
                            </b-col>

                            <b-col class="col-sm-per" sm ="2">
                                <b-form-checkbox
                                v-model="datosTabCtrlGestion.cknoasigcobr"
                                value="s"
                                unchecked-value="n"
                                @change="Asgcknoasigcobranza"
                                >
                                No Asig. Cobranza
                                </b-form-checkbox>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosTabCtrlGestion.fenoasigcobr"  size="sm" ></b-form-input> -->
                                <b-form-datepicker 
                                    id="example-datepicker" 
                                    v-model="datosTabCtrlGestion.fenoasigcobr" 
                                    :default-value="this.datosTabCtrlGestion.fenoasigcobr"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosTabCtrlGestion.usnoasigcobr"  size="sm" disabled></b-form-input>
                            </b-col>
                            
                        </b-row>  
                  
                        
                      </b-container>    

                    </b-card>

                    <b-card>
                        <b-container fluid>
                            <b-row class="my-1" size="sm">
                                <b-col class="col-sm-per" sm ="2">
                                        <b-form-checkbox
                                        v-model="datosTabCtrlGestion.ckfeexcepcion"
                                        value="s"
                                        unchecked-value="n"
                                        @change="asgckfeexcepcion"
                                        >
                                        Fecha Excepción
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col class="col-sm-per" sm ="2">
                                        <!-- <b-form-input v-model="datosTabCtrlGestion.feexcepcion"  size="sm" ></b-form-input> -->
                                        <b-form-datepicker 
                                            v-model="datosTabCtrlGestion.feexcepcion" 
                                            size="sm" 
                                            :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                            locale="ES"
                                            placeholder="Seleccione fecha"
                                            >
                                        </b-form-datepicker> 
                                    </b-col>
                                    
                                    <b-col sm ="3"></b-col>

                                    <b-col class="col-sm-per" sm ="2">
                                        <label>Instancia que Autorizó</label>
                                    </b-col>
                                    <b-col class="col-sm-per" sm ="2">
                                        <b-form-select v-model="datosTabCtrlGestion.instautorizo" :options="lovInstAut" size="sm" ></b-form-select> 
                                    </b-col>
                            
                            </b-row>   

                            <b-row class="my-1" size="sm">
                                <b-col class="col-sm-per" sm ="2">
                                    <label>Monto Excepcionado</label>
                                </b-col>
                                <b-col class="col-sm-per" sm ="2">
                                    <b-input-group size="sm" :prepend="datosFormulario.monmtoexcep">
                                        <b-form-input v-model="datosTabCtrlGestion.mtoexcepcion"  size="sm"></b-form-input>
                                    </b-input-group>
                                    
                                </b-col>
                                <b-col class="col-sm-per" sm ="1"></b-col>
                                <b-col class="col-sm-per" sm ="2">
                                    <label>% Mto Impago Excepcionado</label>
                                </b-col>
                                <b-col class="col-sm-per" sm ="1">
                                    <b-form-input v-model="datosTabCtrlGestion.porcimpaexcepc"  size="sm"></b-form-input>
                                </b-col>

                                <b-col class="col-sm-per" sm ="2">
                                    <label>Número del Acta</label>
                                </b-col>
                                <b-col class="col-sm-per" sm ="1">
                                    <b-form-input v-model="datosTabCtrlGestion.nroacta"  size="sm"></b-form-input>
                                </b-col>

                            </b-row>

                            <b-row class="my-1" size="sm">   
                                <b-col class="col-sm-per" sm ="2">
                                    <label>Observaciones</label>
                                </b-col>
                                <b-col class="col-sm-per" sm ="10">
                                    
                                        <b-form-textarea
                                            id="textarea"
                                            v-model="datosTabCtrlGestion.observaciones"
                                            placeholder="Observaciones..."
                                            rows="2"
                                            size="sm"
                                            max-rows="3"
                                            ></b-form-textarea>
                                </b-col>
                            </b-row>

                            
                        
                        </b-container>    
                    </b-card>

                    <b-card>
                        <b-container fluid>
                            <b-row class="my-1" size="sm">   
                                <b-col class="col-sm-per" sm ="2">
                                    <b-form-checkbox
                                    v-model="datosTabCtrlGestion.ckmarcaprec"
                                    value="s"
                                    unchecked-value="n"
                                    @change="asgckmarcaprec"
                                    >
                                    Precautoria
                                    </b-form-checkbox>
                                </b-col>
                                <b-col class="col-sm-per" sm ="2">
                                    <b-form-datepicker 
                                        id="idfeingreso" 
                                        v-model="datosTabCtrlGestion.femarcaprec" 
                                        :default-value="this.datosTabCtrlGestion.femarcaprec"
                                        size="sm" 
                                        :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                        locale="ES"
                                        disabled
                                        placeholder="Seleccione fecha"
                                        >
                                    </b-form-datepicker> 
                                </b-col>
                                <b-col class="col-sm-per" sm ="1">
                                    <b-form-input v-model="datosTabCtrlGestion.usumarcaprec"  size="sm" disabled></b-form-input>
                                </b-col>
                                <b-col class="col-sm-per" sm ="1">
                                    <b-button size="sm" variant="info" @click="VerHistPrec">...</b-button>
                                </b-col>    
                                <b-col class="col-sm-per" sm ="6">
                                
                                    <b-form-textarea
                                        id="textarea"
                                        v-model="datosTabCtrlGestion.obsmarcaprec"
                                        placeholder="Observaciones..."
                                        rows="2"
                                        size="sm"
                                        max-rows="3"
                                        ></b-form-textarea>
                                </b-col>
                            </b-row>
                        </b-container>    
                    </b-card>                            

                    <b-card>
                        <b-container fluid>
                            <b-row class="my-1" size="sm">
                                <b-col class="col-sm-per" sm ="12">
                                    <label>Observaciones del siniestro</label>
                                    <b-form-textarea
                                        id="textarea"
                                        v-model="datosFormulario.sinobservacion"
                                        placeholder="Observaciones..."
                                        rows="3"
                                        max-rows="6"
                                        ></b-form-textarea>
                                </b-col>
                            </b-row>
                        </b-container>    
                    </b-card>
                    
                </b-tab>

                <b-tab title="Liquidador y Cobrador" id="tabLiquiCobra" @click="defIndex(3)">
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                            <label>N° Siniestro</label>    
                        </b-col>
                        <b-col sm="2"> <b> {{this.datosFormulario.nrosiniestro}}</b></b-col>
                    </b-row>					
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>		  
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Estado</label>    
                            </b-col>
                            <b-col  sm ="2">
                                <b-input-group size="sm">
                                    <b-form-select v-model="datosFormulario.estado" :options="lovEstado" size="sm" ></b-form-select> 
                                    <b-button size="sm" variant="info" @click="VerDetEstado">...</b-button>
                            </b-input-group>
                        </b-col>
                    </b-row>								  	
                    <b-card>
                    <!-- 1era linea  -->
                    <b-container  fluid>
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label> Liquidador Vig.</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.codliquidador"  size="sm" disabled placeholder="Código"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.rutliquidador"  size="sm" disabled placeholder="Rut"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-input v-model="datosFormulario.nomliquidador"  size="sm" disabled placeholder="Nombre"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <!-- <label>Serv.</label> -->
                                <b-form-input v-model="datosFormulario.servliquidador"  size="sm" disabled placeholder="Serv."></b-form-input>
                            </b-col>

                            <b-col class="col-sm-per" sm ="2">
                                <b-button  v-if="datosFormulario.valNoAsigLiq" size="sm" id="ASL" variant="primary" @click="AsigLiquidador">Asig. Liqu.</b-button>
                                <b-button  v-if="datosFormulario.valNoAsigLiq" size="sm" id="TAR" style="margin-left: 10px;" variant="primary" @click="CrearTarea('Enviar a liquid')">Crear tarea</b-button>
                            </b-col>

                            
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-checkbox
                                v-model="datosTabCtrlGestion.cknoasigliq"
                                value="s"
                                unchecked-value="n"
                                @change="Asgcknoasigliq"
                                :disabled="cknoasigliqDisabled"
                                >
                                No Asig. Liq. 
                                </b-form-checkbox>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosTabCtrlGestion.fenoasigcobr"  size="sm" ></b-form-input> -->
                                <b-form-datepicker 
                                    id="example-datepicker" 
                                    v-model="datosTabCtrlGestion.fenoasigliq" 
                                    :default-value="this.datosTabCtrlGestion.fenoasigliq"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosTabCtrlGestion.usnoasigliq"  size="sm" disabled></b-form-input>
                            </b-col>
                            <!-- <b-col class="col-sm-per" sm ="2">
                                <b-form-checkbox
                                id="checkbox-1"
                                v-model="datosFormulario.ckconPreInforme"
                                value="s"
                                unchecked-value="n"
                                >
                                Con Preinforme
                                </b-form-checkbox>
                            </b-col> -->
                        </b-row>
                        <!-- 2da linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="1">
                                <label> Cobrador Vig.</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.codcobrador"  size="sm" disabled placeholder="Código"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.rutcobrador"  size="sm" disabled placeholder="Rut"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-input v-model="datosFormulario.nomcobrador"  size="sm" disabled placeholder="Nombre"></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.servcobrador"  size="sm" disabled placeholder="Serv."></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                    <b-button  v-if="datosFormulario.valNoAsigCobr" size="sm" id="ASC" variant="primary" @click="AsigCobrador">Asig. Cob.</b-button>
                                    <b-button  v-if="datosFormulario.valNoAsigCobr" size="sm" id="TAR" style="margin-left: 10px;" variant="primary" @click="CrearTarea('Enviar a cobran')">Crear tarea</b-button>
                            </b-col>


                            <!-- <b-col class="col-sm-per d-flex justify-content-end" sm ="1">
                                <label>Serv.</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosFormulario.servcobrador"  size="sm" disabled></b-form-input>
                            </b-col> -->

                            <b-col class="col-sm-per" sm ="1">
                                <b-form-checkbox
                                v-model="datosTabCtrlGestion.cknoasigcobr"
                                value="s"
                                unchecked-value="n"
                                @change="Asgcknoasigcobranza"
                                :disabled="cknoasigcobrDisabled"
                                >
                                No Asig. Cob.
                                </b-form-checkbox>
                            </b-col>
                            <b-col class="col-sm-per" sm ="2">
                                <!-- <b-form-input v-model="datosTabCtrlGestion.fenoasigcobr"  size="sm" ></b-form-input> -->
                                <b-form-datepicker 
                                    id="example-datepicker" 
                                    v-model="datosTabCtrlGestion.fenoasigcobr" 
                                    :default-value="this.datosTabCtrlGestion.fenoasigcobr"
                                    size="sm" 
                                    :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                                    locale="ES"
                                    placeholder="Seleccione fecha"
                                    >
                                </b-form-datepicker> 
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosTabCtrlGestion.usnoasigcobr"  size="sm" disabled></b-form-input>
                            </b-col>
                           
                        </b-row>
                        <!-- 3era linea  -->
                        <b-row class="my-1" size="sm">
                            <b-col class="col-sm-per" sm ="12">
                                <label>Observaciones del siniestro</label>
                                <b-form-textarea
                                    id="textarea"
                                    v-model="datosFormulario.sinobservacion"
                                    placeholder="Observaciones..."
                                    rows="3"
                                    max-rows="6"
                                    ></b-form-textarea>
                            </b-col>
                        </b-row>
                    </b-container>
                    </b-card>
                
                </b-tab>
                 <b-tab v-if="this.datosFormulario.nrosiniestro != ''" title="Liquidación" @click="defIndex(4)"> 
				 	<b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>N° Siniestro:</label>    
                            </b-col>
                        <b-col  sm="2"> <b> {{this.datosFormulario.nrosiniestro}}</b></b-col>
                    </b-row>
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>		  
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Estado</label>    
                            </b-col>
                            <b-col  sm ="2">
                                <b-input-group size="sm">
                                    <b-form-select v-model="datosFormulario.estado" :options="lovEstado" size="sm" disabled></b-form-select> 
                                    <b-button size="sm" variant="info" @click="VerDetEstado">...</b-button>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <Liquidacion   									   
                            :nrosiniestro=datosFormulario.nrosiniestro.toString()
                            >
                    </Liquidacion> 
                </b-tab>
                
               <b-tab v-if="this.datosFormulario.nrosiniestro != ''" title="Tareas pendientes" id="tabTareasPend" @click="defIndex(5)">
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>N° Siniestro:</label>    
                            </b-col>
                        <b-col  sm="2"> <b> {{this.datosFormulario.nrosiniestro}}</b></b-col>
                    </b-row>
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>		  
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Estado</label>    
                            </b-col>
                            <b-col  sm ="2">
                                <b-input-group size="sm">
                                    <b-form-select v-model="datosFormulario.estado" :options="lovEstado" size="sm" disabled></b-form-select> 
                                    <b-button size="sm" variant="info" @click="VerDetEstado">...</b-button>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <tareasPend ref="tabtareasPend"  
                        :poliza = datosFormulario.poliza
                        :nroSiniestro = datosFormulario.nrosiniestro
                        >
                    </tareasPend>
                
                </b-tab>
                
                <b-tab v-if="this.datosFormulario.nrosiniestro != ''" title="Contishare" id="tabContishare" @click="defIndex(6)">
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>N° Siniestro:</label>    
                            </b-col>
                        <b-col  sm="2"> <b> {{this.datosFormulario.nrosiniestro}}</b></b-col>
                    </b-row>
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>		  
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Estado</label>    
                            </b-col>
                            <b-col  sm ="2">
                                <b-input-group size="sm">
                                    <b-form-select v-model="datosFormulario.estado" :options="lovEstado" size="sm" disabled></b-form-select> 
                                    <b-button size="sm" variant="info" @click="VerDetEstado">...</b-button>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12">
                            <div ref="refTable">
                                <data-tables
                                ref="refTable3"
                                :data="dataDocContishare"
                                name="table"
                                class="table-responsive"
                                :current-page.sync="pagina"
                                :table-props="tableProps2"
                                :page-size="10"
                                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                                layout="table"
                                @select="handleSelectionChange2"
                                @select-all="selectAll"                  
                                >
                                <el-table-column
                                    v-for="title in titlesDocContishare"
                                    :min-width="title.minwidth"
                                    :prop="title.prop"
                                    :label="title.label"
                                    :key="title.label"
                                    :align="title.align"
                                    
                                    :formatter="formatter"
                                    name="table"
                                    class="table-responsive"
                                ></el-table-column>
                                
                                <el-table-column label="" min-width="100px" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="verDocumento(scope.row.LINK)">Ver</el-button>   
                                </template>
                                </el-table-column>

                                </data-tables>
                            </div>
                      </b-col>
                    </b-row>     
                </b-tab>
                
                <b-tab v-if="this.datosFormulario.poliza != ''" title="Producción" id="tabProducción" @click="defIndex(7)">
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>N° Siniestro:</label>    
                            </b-col>
                        <b-col  sm="2"> <b> {{this.datosFormulario.nrosiniestro}}</b></b-col>
                    </b-row>
                    <b-row class="my-1" size="sm">
                        <b-col sm="9"></b-col>		  
                        <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label>Estado</label>    
                            </b-col>
                            <b-col  sm ="2">
                                <b-input-group size="sm">
                                    <b-form-select v-model="datosFormulario.estado" :options="lovEstado" size="sm" disabled></b-form-select> 
                                    <b-button size="sm" variant="info" @click="VerDetEstado">...</b-button>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <Polizas ref="tabPolizas"  
                        :poliza= datosFormulario.poliza.toString()
                        :cod_asegurado= datosFormulario.codafianzado.toString()
                        :participacion = datosFormulario.participacion
                        :fedesde= convierteFecha(datosFormulario.feinicio)
                        :fehasta= convierteFecha(datosFormulario.fefin)
                        >
                    </Polizas>
                </b-tab>
            </b-tabs>
            
            <template #footer>
                <b-row >
                    <b-col class="d-flex justify-content-between">
                      <b-col class="d-flex justify-content-start">
                        <b-button variant="primary" v-if="btnrco=== true" @click="VerCorrespondencia(datosFormulario.poliza)"><i class="fa fa-arrow-left"></i> Regresar</b-button>
                        <b-button variant="primary" v-if="$route.query.origen === 'seguimientosiniestro'" @click="regresarseg($route.query.origen)"><i class="fa fa-arrow-left"></i> Regresar a Seguimiento</b-button>
                        <b-button variant="primary" v-if="btnatr=== true" @click="tabIndex--, idx_tab(tabIndex)" style="margin-left: 10px;"><i class="fa fa-arrow-left"></i> Atras</b-button>
                        <b-button variant="primary" @click="pre_insertar()" style="margin-left: 10px;"><i class="fa fa-trash"></i> Limpiar</b-button>
                      </b-col>
                      <b-col class="d-flex justify-content-end">  
                        <b-button variant="primary" v-if="accactulizar === true" @click="actualizar_gestctrl">Aplicar Cambios <i class="fa fa-floppy-o"></i></b-button>
                        <b-button variant="primary" v-if="acccrear === true" @click="crear_denuncio">Crear Siniestro <i class="fa fa-plus"></i></b-button>
                        <b-button variant="primary" v-if="btnsig === true" @click="tabIndex++, idx_tab(tabIndex)" style="margin-left: 10px;">Siguiente <i class="fa fa-arrow-right"></i></b-button>
                      </b-col>  
                    </b-col> 
                </b-row>  
            </template>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      :title= "this.datosFormulario.modaltitle"
      cancel-title="Cancelar"
      v-model="modalAsigLiqCob"
      @cancel="modalAsigLiqCob = false"
    >
        <b-row>
            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                <label> Servicio</label>
            </b-col>
            <b-col lg="4">
                <b-form-select v-model="datosFormulario.codservicio" :options="lovServicios" size="sm"  @change="buscarLiqCob('XXX')"></b-form-select> 
            </b-col>
            <b-col lg="1"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input size="sm"
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filterLiqPer[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12">             
                <div ref="refTable3">
                <data-tables ref="refTable3"
                    :data="dataLiqPer"
                    name="tableHistLiqu"
                    class="table-responsive"
                    :current-page.sync="pagina"
                    :table-props="tablePropsLiqPer"
                    :filters="filterLiqPer"
                    :page-size="10"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    layout="table">
                    <el-table-column
                        v-for="title in titlesLiqPer"
                        :min-width="title.minwidth" 
                        :prop="title.prop"
                        :label='title.label'
                        :key="title.label"
                        :align="title.align"
                        sortable="custom"
                        :formatter="formatter"
                        name="table"
                        class="table-responsive">
                            <template slot-scope="scope">
                                <div v-if="title.prop === 'PERNOMBRE'">  
                                    <b-link type="text" v-if="scope.row.PERCODIGO > 0" @click="seleccionar_LiqCob(datosFormulario.codservicio, scope.row.PERCODIGO, scope.row.IDNACION, scope.row.PERNOMBRE)" >{{scope.row.PERNOMBRE}}</b-link>
                                                    <p v-else >{{scope.row.PERNOMBRE}}</p> 
                                                    
                                </div>
                                <p v-else>{{scope.row[title.prop]}}</p>
                            </template>
                    </el-table-column>
                    
                    </data-tables>
                </div>
            </b-col>
        </b-row>
    
        
    </b-modal>

    <b-modal
      size="md"
      scrollable
      hide-footer
      title= "Estado del siniestro"
      cancel-title="Cancelar"
      v-model="modalDetEstado"
      @cancel="modalDetEstado = false"
    >

    <p> <b>Última modificación: </b>{{datosTabCtrlGestion.sndfestado}} <b>Usuario:</b> {{datosTabCtrlGestion.sndusumodest}}</p>

    </b-modal>

    <!-- Detalle Beneficiarios -->
    <b-modal
      size="lg"
      ok-only
      title="Beneficiarios"
      cancel-title="Cancelar"
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalBeneficiarios"
      @ok="modalBeneficiarios = false"
      @cancel="modalBeneficiarios = false"
    >
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="dataBeneficiarios"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                >
                  <el-table-column
                    v-for="title in titlesBeneficiarios"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>

    <b-modal
      size="l"
      scrollable
      hide-footer
      title= "Histórico de Precautoria"
      cancel-title="Cancelar"
      v-model="modalHistPrec"
      @cancel="modalHistPrec = false"
    >
        <b-row>
            <b-col lg="12">             
                <div ref="refTable3">
                <data-tables ref="refTable3"
                    :data="dataHistPrec"
                    name="tableHistPrec"
                    class="table-responsive"
                    :current-page.sync="pagina"
                    :table-props="tablePropsHistPrec"
                    :page-size="10"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    layout="table">
                    <el-table-column
                        v-for="title in titlesHistPrec"
                        :min-width="title.minwidth" 
                        :prop="title.prop"
                        :label='title.label'
                        :key="title.label"
                        :align="title.align"
                        sortable="custom"
                        :formatter="formatter"
                        name="table"
                        class="table-responsive">
                    </el-table-column>
                    
                    </data-tables>
                </div>
            </b-col>
        </b-row>


    </b-modal>
 
  </div>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiGarSiniestros from "@/components/services/apiGarSiniestros";
import apiGarNomina from "@/components/services/apiGarNomina";
import apiGarIndemniza from "@/components/services/apiGarIndemniza";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';
import ModalCrearTarea from '@/views/garantia/crearTarea';
import Polizas from './polizas.vue';
import tareasPend from './tareasPend.vue';
import Liquidacion from './Liquidacion.vue';
export default {
  name: "crearSiniestro",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  
  props: {
    
    deDonde: String,
    origen: String,
    nroCorrespondencia: Number,
    nroSiniestro: Number,
    nroPoliza: Number,
    mtoDenunciado: Number,
    ejecutivo: String,
    asistente: String,
    tag: Number,
    observacion: String,
    sgcfedenuncio: Date

  },
  
  components: {
    cSwitch
  },
  data: function() {
    return {
      tabIndex: 1,
      exportar: false,
      tieneAcceso: true,
      cardPoliza: true,
      cardProvision: false,
      accactulizar: false,
      acccrear: false,
      btnatr: false,
      btnrco: false,
      btnsig: false,
      accLiq: true,
      accCon: true,
      accPro: true,
      accTar: true,

      verbenef: false,

      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      modalEditar: false,
      modalBeneficiarios: false,
      modalAsigLiqCob: false,
      modalDetEstado: false,
      modalHistPrec: false,

      data: [],
      dataPoliza: [],
      dataPoliza2: [],
      dataSiniestro: [],
      dataLiqPer: [],
      dataHistPrec: [],
      dataDocContishare: [],
      dataBeneficiarios:[],
      
      datosTabCtrlGestion:{

        feenvcartaconf: '', // Fecha Env. Carta Conf.
        feenvinfliqase: '', // Fec. Env. Informe Liq. Ase.
        porccoaseguro: '', // Coaseguro (%)
        partcubierta: '', // Parte Cubierta
        nroacta: '', // Número del Acta
        
        feindemnizacion: '', // Fecha Indemnización
		usfeindemnizacion: '', // Usuario Fecha Indemnización
        feestconfig: '', // Fecha Est. Config.
        feemicheqtesore: '', // Fecha Emi. Cheq. Tesorería
        porcimpaexcepc: '', // % Mto Impago Excepcionado
                
		ckdoccompleto: '', // Check List Doc. Completos
        fedoccompleto: '', // Fecha Doc. Completos
        usdoccompleto: '', // Usuario Doc. Completos
                
		ckdocincompleto: '', // Check List Doc. Incompletos
        fedocincompleto: '', // Fecha Doc. Incompletos
        usdocincompleto: '', // Usuario Doc. Incompletos
                
		cknoasigcobr: '', // Check List No Asig. Cobranza
        fenoasigcobr: '', // Fecha No Asig. Cobranza
        usnoasigcobr: '', // Usuario No Asig. Cobranza

        cknoasigliq: '', // Check List No Asig. Liquidador
        fenoasigliq: '', // Fecha No Asig. Liquidador
        usnoasigliq: '', // Usuario No Asig. Liquidador
                
		ckrecepinf: '', // Check List Recepción Informe
        ferecepinf: '', // Fecha Recepción Informe
		tprecepinf: '', // Usuario Recepción Informe

        ckcartcastigo: '', // Check List Carta Castigo
        fecartcastigo: '', // Fecha Carta Castigo

        ckfeexcepcion: '', // Check List Excepción
        feexcepcion: '', // Fecha Excepción

        fesiniestro: '', // Fecha Siniestro
        instanciaaut: '', // Instancia que Autorizó
        monmtoexcepcion:'',
        mtoexcepcion: '', // Monto Excepcionado
        observaciones: '',

        ckmarcaprec: '', // Check List Marca Precautoria
        femarcaprec: '', // Fecha Marca Precautoria
        usumarcaprec: '', // Usuario Marca Precautoria
        obsmarcaprec: '', // Observaciones Marca Precautoria

        sndfestado: '',
        sndusumodest: ''
                

      },

      

      datosFormulario: {
        nrocorrespondencia: '',
        nroordinario: '',
        nrosiniestro: '',
        sucursal: '',
        estado: '',
        feestpago: '',
        asistente: '',
        ejecutivo: '',
        poliza: '',
        endoso: '',
        producto: '',
        moneda: '',
        vigdesde: '',
        vighasta: '',
        fevencultprorr: '',
        codcobertura: '',
        descobertura: '',
        condicionado: '',
        item: '',
        nacion:'',
        
        codcontratante: '',
        rutcontratante: '',
        nomcontratante: '',
        
        codafianzado: '',
        rutafianzado: '',
        nomafianzado: '',
        
        codasegurado: '',
        rutasegurado: '',
        nomasegurado: '', 
        
        codbeneficiario: '',
        rutbeneficiario: '',
        nombeneficiario: '',

        porretencion: '',
        codreaseguro: '',

        monmtoasegurado: '',
        mtoasegurado: '',
        mtodenunciado: '',
        monprovision: '',
        
        mtvoconfig: '',
        feMotivo: '',
        
        codliquidador: '',
        rutliquidador: '',
        nomliquidador: '',
        servliquidador: '',
        
        ckconPreInforme: 'n',
        
        codcobrador: '',
        rutcobrador: '',
        nomcobrador: '',
        servcobrador: '',

        sinobservacion: '',
        fedenuncio: '',
        feingreso:'',
        feentasistenvcob:'',
        usentasistenvcob:'',
        feasistenvcob:'',
        useasistenvcob:'',
        feentasistenvliq:'',
        usentasistenvliq:'',
        feasistenvliq:'',
        useasistenvliq:'',
        fecdefault:'',
        usudefault:'',
        totprovision:'',
        dedonde:'CrearSiniestro',
        codservicio:'',
        modaltitle:'',
        valNoAsigLiq: true,
        valNoAsigCobr: true,
        valCrearTarLiq: true,
        valCrearTarCob: true,
		participacion: 0,
        feinicio:'',
        fefin:'',				 
        },

        titlesBeneficiarios: [
        {
          prop: "SBECODBENEF",
          label: "Razón social Beneficiario",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "STAMONEDA",
          label: "Moneda",
          align: "left",
          minwidth: "150",
        },
        {
          prop: "SBEMONTO",
          label: "Monto a Indemnizar",
          align: "right",
          minwidth: "160",
        }
      ],
        
        titlesLiqPer: [   
            {
            prop: "IDNACION",
            label: "Id. Nación",
            align: "left",
            minwidth:'80'
            },
            {
            prop: "PERCODIGO",
            label: "Código",
            align: "center",
            minwidth:'50'
            },
            {
            prop: "PERNOMBRE",
            label: "Nombre",
            align: "left",
            minwidth:'150'
            },
            {
            prop: "PERNACION",
            label: "Nación",
            align: "center",
            minwidth:'80'
            },
            {
            prop: "PERCIUDAD",
            label: "Ciudad",
            align: "center",
            minwidth:'80'
            },
            {
            prop: "PERDIRECCION",
            label: "Dirección",
            align: "left",
            minwidth:'200'
            },
            {
            prop: "PERCOMUNA",
            label: "Comuna",
            align: "center",
            minwidth:'80'
            },
                
        ],

      titlesHistPrec: [   
            {
            prop: "MARCA",
            label: "Marca",
            align: "center",
            minwidth:'50'
            },
            {
            prop: "SMPOBSERVACION",
            label: "Observación",
            align: "left",
            minwidth:'150'
            },
            {
            prop: "SMPUSUARIO",
            label: "Usuario",
            align: "center",
            minwidth:'60'
            },
             {
            prop: "SMPFMARCA",
            label: "Fecha",
            align: "center",
            minwidth:'60'
            },
        ],

        titlesDocContishare: [
        {
          prop: "CSHTITULO",
          label: "Categoría - Nombre del Documento",
          align: "left",
          minwidth: "250",
        },      
        {
          prop: "FECHA",
          label: "Fecha",
          align: "center",
          minwidth: "120",
        },    
      ],

        filterLiqPer: [
        {
            value: '',
            filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Est. Config'){
                let elDate = new Date(row["Fecha Est. Config"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
        ],

     
      lovEstado: [],
      lovInstAut: [],
      lovMtvoConfig: [],
      lovServicios: [],
      
      value: null,
      datosFormularioEstado: [],
      datosModificacionEstado: [],

      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400,
          rowKey: "Siniestro"
      },
      
      tablePropsLiqPer:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400,
          rowKey: "Siniestro"
      },

      tablePropsHistPrec:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400,
          rowKey: "Siniestro"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect,
    Liquidacion,
	Polizas,
    tareasPend		  
  },
  methods: {

    regresarseg(p_destino){
        console.log(p_destino);
        this.$router.push({ path: p_destino, query: { deDonde: 'crearSiniestro', tag: this.$route.query.tag }});
    },

    verDocumento(link) {
      window.open(link, '_blank');
    },

    VerHistPrec(){
        this.modalHistPrec = true;
        this.buscarHistPrec();
    },

    VerDetEstado(){
        this.modalDetEstado = true;
    },

   
    VerCorrespondencia(p_poliza){
        // console.log(p_poliza);
        this.$router.push({ path: 'RegCorrespondencia', query: { deDonde: 'crearSiniestro', corrPoliza: p_poliza }});
    },

    CrearTarea(p_tarea){
        
        this.$router.push({ path: 'CrearTarea', query: { deDonde: 'crearTarea', 
                                                         tarea: p_tarea, 
                                                         actividad: '',
                                                         nroCorrespondencia: '',
                                                         nroSiniestro: this.datosFormulario.nrosiniestro,
                                                         nroPoliza: this.datosFormulario.poliza,
                                                         ejecutivo: this.datosFormulario.ejecutivo,
                                                         asistente: this.datosFormulario.asistente }});
    },

    provisionar(){
        this.$router.push({ path: 'Provision', query: { deDonde: 'crearSiniestro', 
                                                        estado: this.datosFormulario.estado, 
                                                        moneda: this.datosFormulario.monprovision,
                                                        nroSiniestro: this.datosFormulario.nrosiniestro,
                                                        nroPoliza: this.datosFormulario.poliza,
                                                        nroEndoso: this.datosFormulario.endoso,
                                                        mtoAsegurado: this.datosFormulario.mtoasegurado,
                                                        ejecutivo: this.datosFormulario.ejecutivo,
                                                        asistente: this.datosFormulario.asistente,
                                                        fecRecpInform: this.datosTabCtrlGestion.ferecepinf,
                                                        marcaPrec: this.datosTabCtrlGestion.ckmarcaprec, 
                                                        codbenef: this.datosFormulario.codbeneficiario,
                                                        idnacbenef: this.datosFormulario.rutbeneficiario, 
                                                        nombenef: this.datosFormulario.nombeneficiario}});
        
    },


    // AsigLiquidador(p_nrosiniestro){
    //     this.$router.push({ path: 'AsigLiquidador', query: { deDonde: 'AsigLiquidador', nroSiniestro: p_nrosiniestro }});
    // },

    AsigLiquidador(){
        this.datosFormulario.modaltitle = "Asignar liquidador";
        this.modalAsigLiqCob = true;
        this.datosFormulario.codservicio = 'LI';
        this.buscarLiqCob('LIQ');

    },
    AsigCobrador(){
        this.datosFormulario.modaltitle = "Asignar a cobranza";
        this.modalAsigLiqCob = true;
        this.datosFormulario.codservicio = 'CO';

        this.buscarLiqCob('COB');

    },

    seleccionar_LiqCob(p_servicio, p_percodigo, p_idnacion, p_pernombre){
        if (p_servicio === 'LI' || p_servicio === 'PE' ) {
        
        this.datosFormulario.codliquidador = p_percodigo;
        this.datosFormulario.rutliquidador = p_idnacion;
        this.datosFormulario.nomliquidador = p_pernombre;
        this.datosFormulario.servliquidador = p_servicio;
        this.modalAsigLiqCob = false;
        }
        
        if (p_servicio === 'CO' || p_servicio === 'AB') {
        this.datosFormulario.codcobrador = p_percodigo;
        this.datosFormulario.rutcobrador = p_idnacion;
        this.datosFormulario.nomcobrador = p_pernombre;
        this.datosFormulario.servcobrador = p_servicio;
        this.modalAsigLiqCob = false;
        }

    },
    
    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },

    obt_datcorrespondencia(){
        console.log(this.$route.query.origen);
        
        this.datosFormulario.dedonde = this.$route.query.deDonde;
        this.datosFormulario.nrocorrespondencia = this.$route.query.nroCorrespondencia;
        this.datosFormulario.nrosiniestro = this.$route.query.nroSiniestro;
        this.datosFormulario.poliza = this.$route.query.nroPoliza;
        this.datosFormulario.mtodenunciado = this.$route.query.mtoDenunciado;
        this.datosFormulario.ejecutivo = this.$route.query.ejecutivo;
        this.datosFormulario.asistente = this.$route.query.asistente;
        this.datosFormulario.sinobservacion = this.$route.query.observacion
        this.datosFormulario.fedenuncio = this.$route.query.sgcfedenuncio;
        
        if (this.datosFormulario.poliza != undefined || this.datosFormulario.nrosiniestro != undefined ){
            
            this.buscar();

            if (this.datosFormulario.dedonde === 'siniestrar' ||  this.datosFormulario.dedonde === 'VerSiniestro') {
                 this.btnrco = true;

            } else {
                this.btnrco = false;
            }

        } 

    },
    
    pre_insertar() {

        this.datosFormulario.nroordinario = "";
        this.datosFormulario.nrosiniestro = "";
        this.datosFormulario.nrocorrespondencia = "";
        this.datosFormulario.sucursal = "";
        this.datosFormulario.estado = "";
        this.datosFormulario.feestpago = "";
        this.datosFormulario.asistente = "";
        this.datosFormulario.ejecutivo = "";
        this.datosFormulario.poliza = "";
        this.datosFormulario.producto = "";
        this.datosFormulario.moneda = "";
        this.datosFormulario.vigdesde = "";
        this.datosFormulario.vighasta = "";
        this.datosFormulario.fevencultprorr = "";
        this.datosFormulario.codcobertura = "";
        this.datosFormulario.descobertura = "";
        this.datosFormulario.condicionado = "";
        this.datosFormulario.item = "";
        this.datosFormulario.nacion = "";
        this.datosFormulario.endoso = "";
        this.datosFormulario.codcontratante = "";
        this.datosFormulario.rutcontratante = "";
        this.datosFormulario.nomcontratante = "";
        this.datosFormulario.codafianzado = "";
        this.datosFormulario.rutafianzado = "";
        this.datosFormulario.nomafianzado = "";
        this.datosFormulario.codasegurado = "";
        this.datosFormulario.rutasegurado = "";
        this.datosFormulario.nomasegurado = ""; 
        this.datosFormulario.codbeneficiario = "";
        this.datosFormulario.rutbeneficiario = "";
        this.datosFormulario.nombeneficiario = "";
        this.datosFormulario.porretencion = "";
        this.datosFormulario.codreaseguro = "";
        this.datosFormulario.monmtoasegurado = "";
        this.datosFormulario.mtoasegurado = "";
        this.datosFormulario.mtodenunciado = "";
        this.datosFormulario.monprovision = "";
        this.datosFormulario.mtvoconfig = "";
        this.datosFormulario.feMotivo = "";
        this.datosFormulario.codliquidador = undefined;
        this.datosFormulario.rutliquidador = "";
        this.datosFormulario.nomliquidador = "";
        this.datosFormulario.servliquidador = "";
        this.datosFormulario.ckconPreInforme = "";
        this.datosFormulario.codcobrador = undefined;
        this.datosFormulario.rutcobrador = "";
        this.datosFormulario.nomcobrador = "";
        this.datosFormulario.servcobrador = "";
        this.datosFormulario.sinobservacion = "";
        this.datosFormulario.fedenuncio = "";
        
        this.datosFormulario.feingreso = "";
        this.datosFormulario.feentasistenvcob = "";
        this.datosFormulario.feentasistenvliq = "";
        this.datosFormulario.feasistenvcob = "";
        this.datosFormulario.feasistenvliq = "";
        this.datosFormulario.useasistenvcob = "";
        this.datosFormulario.useasistenvliq = "";
        this.datosFormulario.totprovision = "";

        this.accactulizar = false;
        this.acccrear = false;
        this.btnatr = false;
        this.btnsig =  true;
        this.datosFormulario.valNoAsigLiq = true;
        this.datosFormulario.valNoAsigCobr = true;
        this.datosFormulario.valCrearTarLiq = true;

        


        // 

            this.datosTabCtrlGestion.feenvcartaconf = "";
            this.datosTabCtrlGestion.feenvinfliqase = "";
            this.datosTabCtrlGestion.porccoaseguro = "";
            this.datosTabCtrlGestion.partcubierta = "";
            this.datosTabCtrlGestion.nroacta = "";
            this.datosTabCtrlGestion.feindemnizacion = "";
            this.datosTabCtrlGestion.usfeindemnizacion = "";
            this.datosTabCtrlGestion.feestconfig = "";
            this.datosTabCtrlGestion.feemicheqtesore = "";
            this.datosTabCtrlGestion.porcimpaexcepc = "";
            
            this.datosTabCtrlGestion.ckdoccompleto = "";
            this.datosTabCtrlGestion.fedoccompleto = "";
            this.datosTabCtrlGestion.usdoccompleto = "";
            
            this.datosTabCtrlGestion.ckdocincompleto = "";
            this.datosTabCtrlGestion.fedocincompleto = "";
            this.datosTabCtrlGestion.usdocincompleto = "";
            
            this.datosTabCtrlGestion.cknoasigcobr = "";
            this.datosTabCtrlGestion.fenoasigcobr = "";
            this.datosTabCtrlGestion.usnoasigcobr = "";

            this.datosTabCtrlGestion.cknoasigliq = "";
            this.datosTabCtrlGestion.fenoasigliq = "";
            this.datosTabCtrlGestion.usnoasigliq = "";
            
            this.datosTabCtrlGestion.ckrecepinf = "";
            this.datosTabCtrlGestion.ferecepinf = "";
            this.datosTabCtrlGestion.tprecepinf = "";
            
            this.datosTabCtrlGestion.ckcartcastigo = "";
            this.datosTabCtrlGestion.fecartcastigo = "";
            
            this.datosTabCtrlGestion.ckfeexcepcion = "";
            this.datosTabCtrlGestion.feexcepcion = "";
            
            this.datosTabCtrlGestion.fesiniestro = "";
            this.datosTabCtrlGestion.instautorizo = "";
            this.datosTabCtrlGestion.mtoexcepcion = "";
            this.datosTabCtrlGestion.observaciones = ""; 

            this.datosTabCtrlGestion.ckmarcaprec = "";
            this.datosTabCtrlGestion.femarcaprec = "";
            this.datosTabCtrlGestion.usumarcaprec = "";
            this.datosTabCtrlGestion.obsmarcaprec = ""; 

            this.tabIndex = 0;


      return apiGarSiniestros
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          //Carga lista de Estado
          this.lovEstado = this.llenaArrayLista(response.data.estados, 'codigo', 'descripcion', false);

          //Carga lista de Motivo de Configuración
          this.lovMtvoConfig = this.llenaArrayLista(response.data.mtvoconfig, 'codigo', 'descripcion', false);

          //Carga lista de Instancia que Autorizó
          this.lovInstAut = this.llenaArrayLista(response.data.instautorizo, 'codigo', 'descripcion', false);

        //   this.lovServicios =  this.llenaArrayLista(response.data.servicios, 'codigo', 'descripcion', false);

            //this.datosFormulario.poliza == '' ? '0': this.datosFormulario.poliza;
          //this.datosFormulario.fedenuncio = this.$route.query.fedenuncio == '' ? response.data.datadefault[0]["fecdefault"] : this.$route.query.fedenuncio; //response.data.datadefault[0]["fecdefault"]; //'2024-04-01';//response.data.datadefault[0]["fecdefault"]; //

          //this.datosFormulario.fedenuncio = this.datosFormulario.fedenuncio == '' ? response.data.datadefault[0]["fecdefault"] : this.$route.query.fedenuncio; //response.data.datadefault[0]["fecdefault"]; //'2024-04-01';//response.data.datadefault[0]["fecdefault"]; //
          
          this.datosFormulario.fedenuncio = this.$route.query.sgcfedenuncio; //response.data.datadefault[0]["fecdefault"];
          
          this.datosFormulario.feingreso = response.data.datadefault[0]["feingreso"];
          this.datosTabCtrlGestion.fesiniestro = response.data.datadefault[0]["fesiniestro"];
          this.datosFormulario.sucursal = response.data.datadefault[0]["sucursal"];

          this.datosFormulario.usudefault = response.data.datadefault[0]["usudefault"];
          this.datosFormulario.fecdefault = response.data.datadefault[0]["fecdefault"];
          

        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });

        
    },

    buscarLiqCob(p_accion){
         
         return apiGarSiniestros
        .recuperar_serv(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.codservicio,
          p_accion

        )
        .then(response => {
          this.dataLiqPer  = response.data.res;
          
          if (p_accion != 'XXX') {
            response.data = this.keysMinuscula(response.data);
            this.lovServicios =  this.llenaArrayLista(response.data.servicios, 'codigo', 'descripcion', false);
          }
          this.$Progress.finish();




        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscarHistPrec(){
         
         return apiGarSiniestros
        .recuperar_histprec(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.nrosiniestro
        )
        .then(response => {
          this.dataHistPrec  = response.data.res;
          
          this.$Progress.finish();

        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    

    buscar() {
      this.$Progress.start();

      
      return apiGarSiniestros
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.poliza,
          this.datosFormulario.nrosiniestro
        )
        .then(response => {


          this.dataPoliza  = response.data.res;
          this.dataPoliza2  = response.data.res1;
          this.dataSiniestro  = response.data.res2;
          
        //   if (this.datosFormulario.poliza > 0  && this.datosFormulario.nrosiniestro === '' ){
        //     // this.accactulizar = false;
        //     // this.acccrear = true;
        //   }

          
          this.datosFormulario.codcontratante = this.dataPoliza2[0]["CODCONTRATANTE"];
          this.datosFormulario.rutcontratante = this.dataPoliza2[0]["RUTCONTRATANTE"];
          this.datosFormulario.nomcontratante = this.dataPoliza2[0]["NOMCONTRATANTE"];

          this.datosFormulario.codafianzado = this.dataPoliza[0]["CODAFIANZADO"];
          this.datosFormulario.rutafianzado = this.dataPoliza[0]["RUTAFIANZADO"];
          this.datosFormulario.nomafianzado = this.dataPoliza[0]["NOMAFIANZADO"];
          
          this.datosFormulario.nacion = this.dataPoliza[0]["NACION"];
          
          this.datosFormulario.producto = this.dataPoliza2[0]["MARPRODUCTO"];
          this.datosFormulario.moneda = this.dataPoliza2[0]["MARMONEDA"];
          this.datosFormulario.vigdesde = this.dataPoliza2[0]["MARVIGDESDE"];
          this.datosFormulario.vighasta = this.dataPoliza2[0]["MARVIGHASTA"];

          this.datosFormulario.poliza = this.dataPoliza[0]["ITEPOLIZA"];
          this.datosFormulario.item = this.dataPoliza[0]["ITEITEM"];
          this.datosFormulario.endoso = this.dataPoliza[0]["ITEENDOSO"];

          this.datosFormulario.codcobertura = this.dataPoliza[0]["COBCOBERTURA"];
          this.datosFormulario.descobertura = this.dataPoliza[0]["TCBDESCRIPCION"];
          this.datosFormulario.condicionado = this.dataPoliza[0]["TCBCONDICIONADO"];
          
          this.datosFormulario.codasegurado = this.dataPoliza[0]["CODASEGURADO"];
          this.datosFormulario.rutasegurado = this.dataPoliza[0]["RUTASEGURADO"];
          this.datosFormulario.nomasegurado = this.dataPoliza[0]["NOMASEGURADO"];
          
          this.datosFormulario.codbeneficiario = this.dataPoliza[0]["CODBENEFICIARIO"];
          this.datosFormulario.rutbeneficiario = this.dataPoliza[0]["RUTBENEFICIARIO"];
          this.datosFormulario.nombeneficiario = this.dataPoliza[0]["NOMBENEFICIARIO"];

          this.datosFormulario.monmtoasegurado = this.dataPoliza[0]["ITEMONEDA"];
          this.datosFormulario.mtoasegurado = this.dataPoliza[0]["MTOASEGURADO"];

          this.datosFormulario.porretencion  = this.dataPoliza[0]["RPRRETENCION"];
          this.datosFormulario.codreaseguro = this.dataPoliza[0]["RPRDISTRIBUCION"];
	      this.datosFormulario.estado = "ACT";										  

          // datos del siniestro
          if (this.datosFormulario.nrosiniestro > 0 ){

            this.datosFormulario.endoso = this.dataSiniestro[0]["SNDENDOSO"];
            this.datosFormulario.estado = this.dataSiniestro[0]["SNDESTADO"];
            this.datosFormulario.asistente = this.dataSiniestro[0]["SNDASISTENTE"];
            this.datosFormulario.ejecutivo = this.dataSiniestro[0]["SNDEJECUTIVO"];
            
            this.datosFormulario.monprovision = this.dataSiniestro[0]["SNDMONEDA"]; //this.dataSiniestro[0]["PROVMONEDA"];
            this.datosFormulario.totprovision = this.dataSiniestro[0]["TOTPROVISION"];
            
            this.datosFormulario.monmtoasegurado = this.dataSiniestro[0]["SNDMONEDA"];
            this.datosFormulario.mtoasegurado = this.dataPoliza[0]["MTOASEGURADO"];
            this.datosFormulario.mtodenunciado = this.dataSiniestro[0]["SNDMONTODENUN"];
            this.datosFormulario.mtvoconfig = this.dataSiniestro[0]["MTVOCONFIG"]; 
            this.datosFormulario.feMotivo = this.dataSiniestro[0]["FEMOTIVO"]; 
            this.datosFormulario.monmtoexcep = this.dataSiniestro[0]["MONMTOEXCEP"]; 
            this.datosFormulario.sinobservacion = this.dataSiniestro[0]["SNDOBSERVACION"];
            this.datosTabCtrlGestion.feestconfig = this.dataSiniestro[0]["SNDFESTCONFIG"];
            this.datosFormulario.feentasistenvcob = this.dataSiniestro[0]["FEENVCOB"];
            this.datosFormulario.feentasistenvcob
            
            //   if (this.datosFormulario.feentasistenvcob != undefined){
            //         this.datosFormulario.valCrearTarCob = false;
            //   }
            this.datosFormulario.usentasistenvcob = this.dataSiniestro[0]["USUENVCOB"];
            this.datosFormulario.feentasistenvliq = this.dataSiniestro[0]["FEENVLIQ"];
            
            //   if (this.datosFormulario.feentasistenvliq != undefined){
            //         this.datosFormulario.valCrearTarLiq = false;
            //   }
            this.datosFormulario.usentasistenvliq = this.dataSiniestro[0]["USUENVLIQ"];
            this.datosFormulario.feasistenvcob = this.dataSiniestro[0]["FEASIGCOB"];
            this.datosFormulario.useasistenvcob = this.dataSiniestro[0]["USUFEASIGCOB"];
            this.datosFormulario.feasistenvliq = this.dataSiniestro[0]["FEASIGLIQ"];
            this.datosFormulario.useasistenvliq = this.dataSiniestro[0]["USUFEASIGLIQ"];

            
            this.datosTabCtrlGestion.ckdocincompleto = this.dataSiniestro[0]["SNDDOCINCOMPL"];
            this.datosTabCtrlGestion.fedocincompleto =  this.dataSiniestro[0]["SNDFDOCINCOMPL"];
            this.datosTabCtrlGestion.usdocincompleto =  this.dataSiniestro[0]["SNDDOCINCOMPLUSU"]; 

            this.datosTabCtrlGestion.ckdoccompleto = this.dataSiniestro[0]["SNDDOCCOMPL"];
            this.datosTabCtrlGestion.fedoccompleto = this.dataSiniestro[0]["SNDFDOCCOMPL"];
            this.datosTabCtrlGestion.usdoccompleto = this.dataSiniestro[0]["SNDDOCCOMPLUSU"];

            this.datosTabCtrlGestion.cknoasigcobr = this.dataSiniestro[0]["CKNOASIGCOB"];
            this.datosTabCtrlGestion.fenoasigcobr = this.dataSiniestro[0]["FENOASIGCOB"];
            this.datosTabCtrlGestion.usnoasigcobr = this.dataSiniestro[0]["USNOASIGCOB"];
            this.datosFormulario.fedenuncio = this.dataSiniestro[0]["SNDFDENUNCIO"];
            this.datosFormulario.feingreso = this.dataSiniestro[0]["SNDFINGRESO"];
            this.datosTabCtrlGestion.fesiniestro = this.dataSiniestro[0]["SNDFCONFIG"];

            if (this.datosTabCtrlGestion.cknoasigcobr === 's'){
                this.datosFormulario.valNoAsigCobr = false;
            } else {
                this.datosFormulario.valNoAsigCobr = true;
            }

            this.datosTabCtrlGestion.cknoasigliq = this.dataSiniestro[0]["CKNOASIGLIQ"];
            this.datosTabCtrlGestion.fenoasigliq = this.dataSiniestro[0]["FENOASIGLIQ"];
            this.datosTabCtrlGestion.usnoasigliq = this.dataSiniestro[0]["USNOASIGLIQ"];

            if (this.datosTabCtrlGestion.cknoasigliq === 's'){
                this.datosFormulario.valNoAsigLiq = false;
            } else {
                this.datosFormulario.valNoAsigLiq = true;
            }

            this.datosTabCtrlGestion.ckrecepinf = this.dataSiniestro[0]["CKRECEPINF"];
            this.datosTabCtrlGestion.ferecepinf = this.dataSiniestro[0]["FERECEPINF"];
            this.datosTabCtrlGestion.tprecepinf = this.dataSiniestro[0]["TPRECEPINF"];

            this.datosTabCtrlGestion.ckcartcastigo = this.dataSiniestro[0]["CKCARTCASTIGO"];
            this.datosTabCtrlGestion.fecartcastigo = this.dataSiniestro[0]["SNDFCARTCASTI"];

            this.datosTabCtrlGestion.ckfeexcepcion = this.dataSiniestro[0]["CKFEEXCEPCION"];
            this.datosTabCtrlGestion.feexcepcion = this.dataSiniestro[0]["SNDFEXCEPCION"];

            this.datosTabCtrlGestion.instautorizo = this.dataSiniestro[0]["AUTORIZOEXCEP"];

            this.datosTabCtrlGestion.mtoexcepcion = this.dataSiniestro[0]["MONTOEXCEP"];

            this.datosTabCtrlGestion.feenvcartaconf = this.dataSiniestro[0]["FEENVCARTCONF"];
            this.datosTabCtrlGestion.feenvinfliqase = this.dataSiniestro[0]["FEINFLIQASEG"];
            this.datosTabCtrlGestion.porccoaseguro = this.dataSiniestro[0]["SNDCOASEGURO"];
            this.datosTabCtrlGestion.partcubierta = this.dataSiniestro[0]["PARTCUBIERTA"];
            this.datosTabCtrlGestion.nroacta = this.dataSiniestro[0]["NROACTACOMITE"];
            this.datosTabCtrlGestion.feemicheqtesore = this.dataSiniestro[0]["FEEMICHEQTESOR"];
            this.datosTabCtrlGestion.porcimpaexcepc = this.dataSiniestro[0]["PORCMTOIMPEXCEP"];
            this.datosTabCtrlGestion.feestconfig = this.dataSiniestro[0]["SNDFESTCONFIG"];
            this.datosTabCtrlGestion.observaciones = this.dataSiniestro[0]["OBSERVACIONESEXCEP"];

            this.datosTabCtrlGestion.feindemnizacion = this.dataSiniestro[0]["FEINDEMNIZACION"];
            this.datosTabCtrlGestion.usfeindemnizacion = this.dataSiniestro[0]["FEINDEMNIZUSU"];

            this.datosFormulario.codliquidador = this.dataSiniestro[0]["CODLIQUIDADOR"];
            
            this.datosFormulario.rutliquidador = this.dataSiniestro[0]["RUTLIQUIDADOR"];
            this.datosFormulario.nomliquidador = this.dataSiniestro[0]["NOMLIQUIDADOR"];
            this.datosFormulario.servliquidador = this.dataSiniestro[0]["LIQSERVICIO"];

            this.datosFormulario.codcobrador = this.dataSiniestro[0]["CODCOBRADOR"];
            this.datosFormulario.rutcobrador = this.dataSiniestro[0]["RUTCOBRADOR"];
            this.datosFormulario.nomcobrador = this.dataSiniestro[0]["NOMCOBRADOR"];
            this.datosFormulario.servcobrador = this.dataSiniestro[0]["COBSERVICIO"];

            this.datosFormulario.ckconPreInforme = this.dataSiniestro[0]["SNDPREINFORME"];

            this.datosTabCtrlGestion.ckmarcaprec = this.dataSiniestro[0]["CKMARCAPREC"];
            this.datosTabCtrlGestion.femarcaprec = this.dataSiniestro[0]["FEMARCAPREC"];
            this.datosTabCtrlGestion.usumarcaprec = this.dataSiniestro[0]["USUMARCAPREC"];
            this.datosTabCtrlGestion.obsmarcaprec = this.dataSiniestro[0]["OBSMARCAPREC"];

            this.datosTabCtrlGestion.sndfestado = this.dataSiniestro[0]["SNDFESTADO"];
            this.datosTabCtrlGestion.sndusumodest =  this.dataSiniestro[0]["SNDUSUMODEST"];

            this.DocContishare(this.datosFormulario.nrosiniestro);

          }

          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    crear_denuncio(){
        

        if (this.datosFormulario.mtvoconfig === '') {
            this.crearNotificacion("Error de sistema", "Debe ingresar Motivo de Configuración", "error");
            // this.tabIndex = 1;
            this.defIndex(1);
            return false;
        } else if (this.datosFormulario.mtodenunciado === '') {
            this.crearNotificacion("Error de sistema", "Debe tener Mto. Denunciado", "error");
            // this.tabIndex = 1;
            this.defIndex(1);
            return false;
        } else if (this.datosTabCtrlGestion.feestconfig === '') {
            this.crearNotificacion("Error de sistema", "Debe ingresar Fecha Est. Config.", "error");
            // this.tabIndex = 2;
            this.defIndex(2);
            return false;
        }

        return apiGarSiniestros
        .crear_denuncio(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.nroordinario,
            this.datosFormulario.nrosiniestro,
            this.datosFormulario.sucursal,
            this.datosFormulario.estado,
            this.datosFormulario.asistente,
            this.datosFormulario.ejecutivo,
            this.datosFormulario.poliza,
            this.datosFormulario.producto,
            this.datosFormulario.codafianzado,
            this.datosFormulario.item,
            this.datosFormulario.endoso,
            this.datosFormulario.codasegurado,
            this.datosFormulario.codbeneficiario,
            this.datosFormulario.monmtoasegurado,
            this.$numeral(this.datosFormulario.mtodenunciado)._value,
            this.datosFormulario.mtvoconfig,
            this.datosFormulario.feMotivo,
            this.datosFormulario.codliquidador,
            this.datosFormulario.servliquidador,
            this.datosFormulario.ckconPreInforme,
            this.datosFormulario.codcobrador,
            this.datosFormulario.servcobrador,
            this.datosFormulario.sinobservacion,
            this.datosTabCtrlGestion.porccoaseguro,
            this.datosTabCtrlGestion.feestconfig,
            this.datosFormulario.nrocorrespondencia,
            this.datosFormulario.fedenuncio
        )
        .then(response => {
            this.datosFormulario.nrosiniestro = response.data.args_out.p_nrosiniestro;
            this.$Progress.finish();
            this.crearNotificacion(
                "Creación",
                "Siniestro Creado Satisfactoriamente.",
                "success"
              );
            this.actualizar_gestctrl ();
            this.buscar();
            // this.tabIndex = 0;
            
        
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });

    },

    actualizar_gestctrl(){

        this.$Progress.start();
        
        return apiGarSiniestros
            .actualizar_gestctrl(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.datosFormulario.nrosiniestro,
                this.datosTabCtrlGestion.feenvcartaconf, // p_feenvcartaconf, // Fecha Env. Carta Conf.
                this.datosTabCtrlGestion.feenvinfliqase, //  p_fecenvinfliqase, // Fec. Env. Informe Liq. Ase.
                this.datosTabCtrlGestion.porccoaseguro, // p_coaseguro, // Coaseguro (%)
                this.datosTabCtrlGestion.partcubierta, // p_partcubierta, // Parte Cubierta
                this.datosTabCtrlGestion.nroacta, // p_nroacta, // Número del Acta
                this.datosTabCtrlGestion.feestconfig, // p_feestconfig, // Fecha Est. Config.
                this.datosTabCtrlGestion.feemicheqtesore, // p_feemicheqtesore, // Fecha Emi. Cheq. Tesorería
                this.datosTabCtrlGestion.porcimpaexcepc, // p_porcimpaexcepc, // % Mto Impago Excepcionado
                
                this.datosTabCtrlGestion.ckdoccompleto, // p_ckdoccompleto, // Check List Doc. Completos
                this.datosTabCtrlGestion.fedoccompleto, // p_fedoccompleto, // Fecha Doc. Completos
                this.datosTabCtrlGestion.usdoccompleto, // p_usdoccompleto, // Usuario Doc. Completos
                
                this.datosTabCtrlGestion.ckdocincompleto, // p_ckdocincompleto, // Check List Doc. Incompletos
                this.datosTabCtrlGestion.fedocincompleto, // p_fedocincompleto, // Fecha Doc. Incompletos
                this.datosTabCtrlGestion.usdocincompleto, // p_usudocincompleto, // Usuario Doc. Incompletos
                
                this.datosTabCtrlGestion.cknoasigcobr, // p_cknoasigcobr, // Check List No Asig. Cobranza
                this.datosTabCtrlGestion.fenoasigcobr, // p_fenoasigcobr, // Fecha No Asig. Cobranza
                this.datosTabCtrlGestion.usnoasigcobr, // p_usnoasigcobr, // Usuario No Asig. Cobranza
                
                this.datosTabCtrlGestion.cknoasigliq, // p_cknoasigliq, // Check List No Asig. Liquidador
                this.datosTabCtrlGestion.fenoasigliq, // p_fenoasigliq, // Fecha No Asig. Liquidador
                this.datosTabCtrlGestion.usnoasigliq, // p_usnoasigliq, // Usuario No Asig. Liquidador
                
                this.datosTabCtrlGestion.ckrecepinf, // p_ckrecepcioninfor, // Check List Recepción Informe
                this.datosTabCtrlGestion.ferecepinf, // p_ferecepcioninfor, // Fecha Recepción Informe
                this.datosTabCtrlGestion.tprecepinf, // p_usrecepcioninfor, // Usuario Recepción Informe
                
                this.datosTabCtrlGestion.ckcartcastigo, // p_ckfecartacastigo, // Check List Carta Castigo
                this.datosTabCtrlGestion.fecartcastigo, // p_fecartacastigo, // Fecha Carta Castigo
                
                this.datosTabCtrlGestion.ckfeexcepcion, // p_ckfeexcepcion, // Check List Excepción
                this.datosTabCtrlGestion.feexcepcion, // p_feexcepcion, // Fecha Excepción
                
                this.datosTabCtrlGestion.fesiniestro, // p_fesiniestro, // Fecha Siniestro
                this.datosTabCtrlGestion.instautorizo, // p_instanciaaut, // Instancia que Autorizó
                this.datosTabCtrlGestion.mtoexcepcion, // p_mtoexcepcion, // Monto Excepcionado
                this.datosTabCtrlGestion.observaciones,  // p_observaciones
                
                this.datosFormulario.ckconPreInforme,  // Con Preinforme
                // this.datosFormulario.mtodenunciado,
                this.$numeral(this.datosFormulario.mtodenunciado)._value,
                this.datosFormulario.mtvoconfig, // Motivo de Configuración
                this.datosFormulario.feMotivo, // Fecha Motivo
                this.datosFormulario.codliquidador,
                this.datosFormulario.servliquidador,
                this.datosFormulario.codcobrador,
                this.datosFormulario.servcobrador,

                this.datosTabCtrlGestion.ckmarcaprec, // p_ckmarcaprec, // Check List Marca Precautoria
                this.datosTabCtrlGestion.femarcaprec, // p_femarcaprec, // Fecha Marca Precautoria
                this.datosTabCtrlGestion.usumarcaprec, // p_usumarcaprec, // Usuario Marca Precautoria
                this.datosTabCtrlGestion.obsmarcaprec, // p_obsmarcaprec, // Observaciones Marca Precautoria

                this.datosFormulario.sinobservacion,
                this.datosFormulario.estado,
            ) 
            .then(response => {
            
            this.crearNotificacion(
                "Actualización",
                "Siniestro Actualizado Satisfactoriamente.",
                "success"
              );
            this.$Progress.finish();  
            this.buscar();
            // this.tabIndex = 0;
            
        
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });

    },

    

    asigfecha(){
      this.datosFormulario.feMotivo = this.datosFormulario.feingreso; 
    },
    
    Asgckdoccompleto(checked){

        if (checked === 's' ){
            this.datosTabCtrlGestion.fedoccompleto  = this.datosFormulario.fecdefault; 
            this.datosTabCtrlGestion.usdoccompleto = this.datosFormulario.usudefault; 
        } else {
            this.datosTabCtrlGestion.fedoccompleto  = null; 
            this.datosTabCtrlGestion.usdoccompleto = null; 
        }
        
    },

    Asgckdocincompleto(checked){

        if (checked === 's' ){
            this.datosTabCtrlGestion.fedocincompleto  = this.datosFormulario.fecdefault; 
            this.datosTabCtrlGestion.usdocincompleto = this.datosFormulario.usudefault; 
        } else {
            this.datosTabCtrlGestion.fedocincompleto  = null; 
            this.datosTabCtrlGestion.usdocincompleto = null; 
        }
        
    },

    Asgcknoasigcobranza(checked){

        if (checked === 's' ){
            this.datosTabCtrlGestion.fenoasigcobr  = this.datosFormulario.fecdefault; 
            this.datosTabCtrlGestion.usnoasigcobr = this.datosFormulario.usudefault; 
            this.datosFormulario.valNoAsigCobr = false;
            this.datosFormulario.codcobrador = undefined;
            this.datosFormulario.rutcobrador = null;
            this.datosFormulario.nomcobrador = null;
            this.datosFormulario.servcobrador = null;

        } else {
            this.datosTabCtrlGestion.fenoasigcobr  = null; 
            this.datosTabCtrlGestion.usnoasigcobr = null; 
            this.datosFormulario.valNoAsigCobr = true;
        }
        
    },

    Asgcknoasigliq(checked){

        if (checked === 's' ){
            this.datosTabCtrlGestion.fenoasigliq  = this.datosFormulario.fecdefault; 
            this.datosTabCtrlGestion.usnoasigliq = this.datosFormulario.usudefault; 
            this.datosFormulario.valNoAsigLiq = false;
            this.datosFormulario.codliquidador = undefined;
            this.datosFormulario.rutliquidador = null;
            this.datosFormulario.nomliquidador = null;
            this.datosFormulario.servliquidador = null;
        } else {
            this.datosTabCtrlGestion.fenoasigliq  = null; 
            this.datosTabCtrlGestion.usnoasigliq = null; 
            this.datosFormulario.valNoAsigLiq = true;
        }
        
    },

    asgckrecepinf(checked){

        if (checked === 's' ){
            this.datosTabCtrlGestion.ferecepinf  = this.datosFormulario.fecdefault; 
            this.datosTabCtrlGestion.tprecepinf = 'L'; 
        } else {
            this.datosTabCtrlGestion.ferecepinf  = null; 
            this.datosTabCtrlGestion.tprecepinf = null; 
        }
        
    },

    asgckcartcastigo(checked){

        if (checked === 's' ){
            this.datosTabCtrlGestion.fecartcastigo  = this.datosFormulario.fecdefault; 
      
        } else {
            this.datosTabCtrlGestion.fecartcastigo  = null; 
      
        }
        
    },

    asgckfeexcepcion(checked){

        if (checked === 's' ){
            this.datosTabCtrlGestion.feexcepcion  = this.datosFormulario.fecdefault; 
      
        } else {
            this.datosTabCtrlGestion.feexcepcion  = null; 
      
        }
        
    },

    asgckmarcaprec(checked){
            // this.datosTabCtrlGestion.ckmarcaprec = this.datosFormulario.chkmarcaprec;
            this.datosTabCtrlGestion.femarcaprec  = this.datosFormulario.fecdefault; 
            this.datosTabCtrlGestion.usumarcaprec = this.datosFormulario.usudefault; 
            // this.datosTabCtrlGestion.obsmarcaprec = this.datosFormulario.obsmarcaprec; 
    },

 DocContishare(siniestro){
      this.$Progress.start();
      return apiGarNomina
        .DocContishare(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          siniestro
        )
        .then((response) => {
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          this.dataDocContishare = response.data.res1;
        //   this.datalink = row;
          this.modalDocContishare = true;
          
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    defIndex(p_tabindex){
        this.tabIndex = p_tabindex;
      if (p_tabindex < 4 & this.datosFormulario.nrosiniestro > 0 ){
		
        if (this.datosFormulario.nrosiniestro > 0 ){
            this.accactulizar = true;
            this.acccrear = false;
        }
        if (p_tabindex > 0 & this.datosFormulario.nrosiniestro > 0 ){
            this.btnatr = true;    
        }
        if (p_tabindex === 0){
            this.btnatr = false;
        }


      } else if (p_tabindex === 2){
        
        if (this.datosFormulario.poliza > 0  && (this.datosFormulario.nrosiniestro === '' || this.datosFormulario.nrosiniestro === undefined) ){
            this.accactulizar = false;
            this.acccrear = true;
        } else {
            this.accactulizar = false;
            this.acccrear = false;
        }
        this.btnrco = false;
        this.btnsig = false;
        this.btnatr = true;

      } else if (p_tabindex === 0){

        if (this.datosFormulario.dedonde === 'siniestrar' ||  this.datosFormulario.dedonde === 'VerSiniestro') {
            this.btnrco = true;

        } else {
            this.btnrco = false;
        }

        this.btnatr = false;
        this.btnsig = true;
        this.acccrear = false;
        this.accactulizar = false;
        
      } else {
        this.btnrco = false;
        this.btnatr = true;
        this.btnsig = true;
        this.acccrear = false;
        this.accactulizar = false;
        
      }

    },

    idx_tab(p_tab){
       console.log(p_tab);
      if (p_tab < 4 & this.datosFormulario.nrosiniestro > 0){

        if (this.datosFormulario.nrosiniestro > 0 ){
            this.accactulizar = true;
            this.acccrear = false;
        }
        if (p_tab > 0 & this.datosFormulario.nrosiniestro > 0 ){
            this.btnatr = true;    
        }
        if (p_tab === 0){
            this.btnatr = false;
        }
        

      } else if (p_tab === 2){
	  
        if (this.datosFormulario.poliza > 0  && (this.datosFormulario.nrosiniestro === '' || this.datosFormulario.nrosiniestro === undefined) ){
            this.accactulizar = false;
            this.acccrear = true;

        } else {
            this.accactulizar = false;
            this.acccrear = false;
        } 
        
        this.btnrco = false;
        this.btnsig = false;
        this.btnatr = true;

      } else if (p_tab === 0){

        if (this.datosFormulario.dedonde === 'siniestrar' ||  this.datosFormulario.dedonde === 'VerSiniestro') {
            this.btnrco = true;
        } else {
            this.btnrco = false;
        }

        this.btnatr = false;
        this.btnsig = true;
        this.acccrear = false;
        this.accactulizar = false;

      } else {
        this.btnrco = false;
        this.btnatr = true;
        this.btnsig = true;
		if (this.datosFormulario.nrosiniestro > 0 ){
            this.accactulizar = true;
            this.acccrear = false;							 
        } 
      }
    },


    formatternum(value) {
        console.log('formatternum: ', value);
        return this.$numeral(value).format("0,0.00");
    },


    formatter(row, column) {
      
      if ((column.property == "MODIFICACION"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      }
      else if ((column.property == "Monto Indemnizado en MonPol" ||
                column.property == "Monto Impago Inicial en MonPol" ||
                column.property == "Devolución recuperos en MonPol" ||
                column.property == "Coaseguro" ||
                column.property == "Parte Cubierta"
      ) && row[column.property]) {
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format('0,0.00');
        }
      }
      else if ((column.property == "Monto Impago" ||
                column.property == "Monto Indemnizado en CLP" ||
                column.property == "Devolución recuperos en CLP" ||
                column.property == "Número de Casos" ||
                column.property == "Activo" ||
                column.property == "Cerrado" ||
                column.property == "Desistido" ||
                column.property == "Indemnizado" ||
                column.property == "Plan de Pago" ||
                column.property == "Rechazado" ||
                /*
                column.property == "Anulado" ||
                column.property == "Apelado" ||
                column.property == "Doc. Incompletos" ||*/
                column.property == "Indemnizaciones" ||
                column.property == "Devoluciones" ||
                column.property == "Inf. Liq. Pendiente" ||
                column.property == "Casos Castigados" ||
                column.property == "Casos Excepcionados"
               ) && row[column.property]){
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format();
        }
      }
      else {
        return row[column.property];
      }
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Cta Cte Beneficiarios</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 1
      for (var key in this.data) {
          
          if(this.data[key]["PRODUCTO"] == undefined){
              this.data[key]["PRODUCTO"] = "";
          }
          if(this.data[key]["EJECUTIVO"] == undefined){
              this.data[key]["EJECUTIVO"] = "";
          }
          if(this.data[key]["NOMBENEF"] == undefined){
              this.data[key]["NOMBENEF"] = "";
          }
          if(this.data[key]["BENEFICIARIO"] == undefined){
              this.data[key]["BENEFICIARIO"] = "";
          }
          if(this.data[key]["IDNACBENEF"] == undefined){
              this.data[key]["IDNACBENEF"] = "";
          }
          if(this.data[key]["MONEDA"] == undefined){
              this.data[key]["MONEDA"] = "";
          }
          if(this.data[key]["BANCO"] == undefined){
              this.data[key]["BANCO"] = "";
          }
          if(this.data[key]["TIPOCUENTA"] == undefined){
              this.data[key]["TIPOCUENTA"] = "";
          }
          if(this.data[key]["CUENTA"] == undefined){
              this.data[key]["CUENTA"] = "";
          }
          if(this.data[key]["LIBRE"] == undefined){
              this.data[key]["LIBRE"] = "";
          }
          if(this.data[key]["MODIFICACION"] == undefined){
              this.data[key]["MODIFICACION"] = "";
          }
          if(this.data[key]["USUARIO"] == undefined){
              this.data[key]["USUARIO"] = "";
          }
          

          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["PRODUCTO"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["EJECUTIVO"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["NOMBENEF"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["BENEFICIARIO"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["IDNACBENEF"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["MONEDA"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["BANCO"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["TIPOCUENTA"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["CUENTA"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["LIBRE"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["MODIFICACION"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["USUARIO"]+"</td>\n";
            
          cuerpo += "</tr>\n";
      }

      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    handleSelectionChange2(selection, row) {

      this.nomdoccontish = row.CSHTITULO;
      this.linkdoccontish = row.LINK;

      if (selection.length > 1 ) {
            this.crearNotificacion("Error de sistema", "Solo se puede seleccionar un solo registro", "error");
            this.$refs.refTable3.$children[0].toggleRowSelection(row, false);
            return;
           }
    },

    selectAll(rows){
      this.$refs.refTable3.$children[0].clearSelection();
      return;
    },

    detalleBeneficiarios(siniestro){
        apiGarIndemniza
            .beneficiarios(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestro
            )
            .then(response => {
            this.$Progress.finish();
            this.dataBeneficiarios = response.data.res;
            this.modalBeneficiarios = true;
            })
            .catch(error => {
            this.modalBeneficiarios = false;
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
            });
    },

    validarBeneficiarios(siniestro){
        apiGarIndemniza
            .beneficiarios(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestro
            )
            .then(response => {
            
            this.dataBeneficiarios = response.data.res;
            
            console.log('dataBeneficiarios', this.dataBeneficiarios.length, siniestro);

                if (this.dataBeneficiarios.length > 0){
                    this.verbenef = true;
                } else {
                    this.verbenef = false;
                }
                
                this.$Progress.finish();
            })
            .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
            });
    }
  },
  
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    this.obt_datcorrespondencia();
    this.validarBeneficiarios(this.$route.query.nroSiniestro);
  },

  computed: {
  cknoasigliqDisabled: function() {
        // console.log(this.datosFormulario.codliquidador);
      if (this.datosFormulario.codliquidador === undefined){
        return false;        
      } else {
        return true;
      }
      
    },

    cknoasigcobrDisabled: function() {
        // console.log(this.datosFormulario.codcobrador);
      if (this.datosFormulario.codcobrador === undefined){
        return false;        
      } else {
        return true;
      }
    },

},


  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.label-blanco{
  color: #fff;
}

.col-sm-per{
    position: relative;
    width: 100%;
    padding-right: 5px;
    padding-left: 5px;
    padding-bottom: 2px;
    padding-top: 2px;
}


</style>
